{
  "version": 1,
  "evidence": "Original SWF symbol extraction. The dated 2009 official battle screenshot remains the layout authority.",
  "referenceScreenshot": "assets/reference/official/images/2009_28-3703_reference_00.jpg",
  "assets": {
    "windArrow": {
      "path": "/game/ui/classic/windArrow/frame-00.svg",
      "frames": [
        "/game/ui/classic/windArrow/frame-00.svg",
        "/game/ui/classic/windArrow/frame-01.svg",
        "/game/ui/classic/windArrow/frame-02.svg",
        "/game/ui/classic/windArrow/frame-03.svg",
        "/game/ui/classic/windArrow/frame-04.svg",
        "/game/ui/classic/windArrow/frame-05.svg",
        "/game/ui/classic/windArrow/frame-06.svg",
        "/game/ui/classic/windArrow/frame-07.svg",
        "/game/ui/classic/windArrow/frame-08.svg",
        "/game/ui/classic/windArrow/frame-09.svg",
        "/game/ui/classic/windArrow/frame-10.svg",
        "/game/ui/classic/windArrow/frame-11.svg",
        "/game/ui/classic/windArrow/frame-12.svg",
        "/game/ui/classic/windArrow/frame-13.svg"
      ],
      "width": 75,
      "height": 43,
      "anchor": {
        "x": 22,
        "y": 11
      },
      "frameRate": 25,
      "sha256": [
        "ff7a7bcfe37333d41bdd65b84bf51a93e6eaff193cd22062db5a326bb7f60210",
        "5dbbd0daef09ded48cc17688ed3cca3425defe8807e0641a33a18d331d0d75e0",
        "c0506131411a99222dd40cea0b045d151c187e0bd8e7d4e10f58648de2edf157",
        "f3a1393235bbb0e82da7a4aadacd3e47789b11f3668962bcf4e19c756616bcd1",
        "0679e5111d39eb32fa1a1652dbce7d4c380d14a9db210f1f72828e6f9b49ccd3",
        "3cf7c30324d3a703b55d10d99d9b9fda63f0f2348b2b0c3f0092fe3fcce93334",
        "cd4a29c871c7771ba6e0bd2cb1c13b8c716d77e5f39b2d62c67b0e35b339fa8e",
        "4bd9cd6c56d7732715b494d9c835aefb227d9d14fb20cfeb8f20af1df485fa11",
        "de54b545c22cad840f0b4f509c50e80452c04ad8368e1e845258a3e6bcabe67b",
        "9334cac8e6cd276cc5985fe3fe60fe02f0d22c4c8f061f8e1273aff696f59f3a",
        "bad2b18903ddca91ce85dd3865734ded659af6e431a55e7888f4dfc22542e5a2",
        "1ac805ce064ce3b44d7f10776bc418b5bf3084324a7560834bc927636eb587e3",
        "7d06532f993f5600c7aeefc68ddaf43baef4cbb6cd57e24da1bcc31a306ef9e1",
        "d17eab8ad588079498a5fa676fe2f5c86f4732db93874823ceeeb063c7c9bfb5"
      ],
      "sourceCharacterId": 182,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.vaneAsset"
    },
    "turnArrow": {
      "path": "/game/ui/classic/turnArrow/frame-00.svg",
      "frames": [
        "/game/ui/classic/turnArrow/frame-00.svg",
        "/game/ui/classic/turnArrow/frame-01.svg",
        "/game/ui/classic/turnArrow/frame-02.svg",
        "/game/ui/classic/turnArrow/frame-03.svg",
        "/game/ui/classic/turnArrow/frame-03.svg",
        "/game/ui/classic/turnArrow/frame-03.svg",
        "/game/ui/classic/turnArrow/frame-03.svg",
        "/game/ui/classic/turnArrow/frame-03.svg",
        "/game/ui/classic/turnArrow/frame-08.svg",
        "/game/ui/classic/turnArrow/frame-08.svg",
        "/game/ui/classic/turnArrow/frame-10.svg",
        "/game/ui/classic/turnArrow/frame-10.svg",
        "/game/ui/classic/turnArrow/frame-12.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-13.svg",
        "/game/ui/classic/turnArrow/frame-03.svg",
        "/game/ui/classic/turnArrow/frame-40.svg",
        "/game/ui/classic/turnArrow/frame-41.svg",
        "/game/ui/classic/turnArrow/frame-42.svg",
        "/game/ui/classic/turnArrow/frame-43.svg",
        "/game/ui/classic/turnArrow/frame-43.svg",
        "/game/ui/classic/turnArrow/frame-43.svg"
      ],
      "width": 1349,
      "height": 120,
      "anchor": {
        "x": 428,
        "y": 14
      },
      "frameRate": 25,
      "sha256": [
        "bb93597397524cca28a3cd29ec58000465fd13a0c203b2cb9e5e9e0018af0bfe",
        "0b2cee193c8752e554ca28e27a0f3214b605d87c85e0d0ee863bcb728b1496e0",
        "b42d0e2e8a730bd0a0d58f32325bf3a767401c2bc77300b069cbf7b19cb8ab5b",
        "f008c1f0cd5e2a80ad0304f11e0632c079b007138f6969f08c257b9a68b5918c",
        "f008c1f0cd5e2a80ad0304f11e0632c079b007138f6969f08c257b9a68b5918c",
        "f008c1f0cd5e2a80ad0304f11e0632c079b007138f6969f08c257b9a68b5918c",
        "f008c1f0cd5e2a80ad0304f11e0632c079b007138f6969f08c257b9a68b5918c",
        "f008c1f0cd5e2a80ad0304f11e0632c079b007138f6969f08c257b9a68b5918c",
        "6cfead59afed177a462cbce82426c9da356cd2a622fc6615e2188d41ad69c5ee",
        "6cfead59afed177a462cbce82426c9da356cd2a622fc6615e2188d41ad69c5ee",
        "e5305e07dad5bdf94ee2220413a043d4060f5070125d86418ec8b640e88daec1",
        "e5305e07dad5bdf94ee2220413a043d4060f5070125d86418ec8b640e88daec1",
        "a7195dae90faa9bfbe835051145f73c9fdd349f7312954b660725c4c1842b65b",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "a69d8c54a308e80bf9786ce235f371a7708178a04fe7752897f85a08b9a12746",
        "f008c1f0cd5e2a80ad0304f11e0632c079b007138f6969f08c257b9a68b5918c",
        "8b847d08e33630a2a108dfcd26acf6144a4eb47f04d9aa05cbb18048f5f5e0bc",
        "2e2832b7c0ff3edeccf39a04b7a56002c0f2799f4ad39a13595071dbb4aba02b",
        "34b26e55c9ca8244dc4017b15cda37a3bccc003a28fd08cbe8de09110d432ee7",
        "aaea153ee87a94c4698b4696e8d5fe66e25f0600234532291f5685e858b4ee5e",
        "aaea153ee87a94c4698b4696e8d5fe66e25f0600234532291f5685e858b4ee5e",
        "aaea153ee87a94c4698b4696e8d5fe66e25f0600234532291f5685e858b4ee5e"
      ],
      "sourceCharacterId": 188,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.TurnAsset"
    },
    "turnGlow": {
      "path": "/game/ui/classic/turnGlow/frame-00.svg",
      "frames": [
        "/game/ui/classic/turnGlow/frame-00.svg",
        "/game/ui/classic/turnGlow/frame-01.svg",
        "/game/ui/classic/turnGlow/frame-02.svg",
        "/game/ui/classic/turnGlow/frame-03.svg",
        "/game/ui/classic/turnGlow/frame-04.svg",
        "/game/ui/classic/turnGlow/frame-05.svg",
        "/game/ui/classic/turnGlow/frame-06.svg",
        "/game/ui/classic/turnGlow/frame-07.svg",
        "/game/ui/classic/turnGlow/frame-08.svg",
        "/game/ui/classic/turnGlow/frame-09.svg",
        "/game/ui/classic/turnGlow/frame-10.svg",
        "/game/ui/classic/turnGlow/frame-11.svg",
        "/game/ui/classic/turnGlow/frame-12.svg",
        "/game/ui/classic/turnGlow/frame-13.svg",
        "/game/ui/classic/turnGlow/frame-14.svg",
        "/game/ui/classic/turnGlow/frame-15.svg",
        "/game/ui/classic/turnGlow/frame-16.svg",
        "/game/ui/classic/turnGlow/frame-17.svg",
        "/game/ui/classic/turnGlow/frame-18.svg",
        "/game/ui/classic/turnGlow/frame-19.svg"
      ],
      "width": 91,
      "height": 34,
      "anchor": {
        "x": 47,
        "y": 18
      },
      "frameRate": 25,
      "sha256": [
        "181bcfa78765e6fbdcec537492776bb977bbffe848e52ccdb47b1583dfbe44d6",
        "b131125c7f8d2fa8d52f149d05e4dc08fa795997444ae3aed30079bd74be7a77",
        "8d2b71a0f3b4952d30792b1d3ade03791bfe5721712983bc6de80a79d02a1c30",
        "cc3b495f6da6706de732302093861b47dfef1aabcd0fa0c8bd5522f828bfb8f1",
        "92631f27dc1e5a0e680b9b72a4d3fae413d376a30b7a786c95a24c00718f4820",
        "f3d753fcb62d128460b3a3ed6026912485811a298dff6d40a915938e797fc0ae",
        "6c1f53cd09f9deacc151977171d7ce522517ebbea9bf97495509160c406b9462",
        "a5c405680ef155457c2679b772e6ea2aaf656893ec5a9ea83b9feca736177695",
        "12c3deab6db65f7faab08e7153777968a1ddb418387417ce3b4589f3e196ae1f",
        "c18b53bdbe440ee4060ac747fd29990ebe9697bd35f902ceac54501d50ac788b",
        "67b5ff798b2c1c982eee37fa9039a4aba1737fd9cb963a275fd64352f5307af2",
        "e3af4efc0d7a0ed56865cb6c676bec4106cb07c5aaf5043eadb839ae2b32ef01",
        "caf0a5e39346090d107c227c86e5b9d6eb12300e9fec2d9268de946170544d40",
        "ad55c115b9906632df8518333a3c96725c6fbd0e06d46dd26440363de35db81e",
        "b95bf9b5c282735d4b9fd58c9a75e4b4d078f82a41c6a06f8bfdeb47855d9149",
        "7a04a14fe6620f47e0dd014ea69aa0a3cee3894e9eb4abc7f8bbac9a803b43a5",
        "a0ce95b08a85125579b3d0d773d02b12b9750c584fa675b2c4a0f898e82c4760",
        "c1dd3f28bb36ab718b74c6e7fc2f35b983aa6e3aaf45d1e79692d2489554cc47",
        "2b62adbfd0bc821c0dce6c3e3916472b433a3327ee0873bc86388cac6b5cd3a3",
        "324173d451117c0259c3c713bf66354df11fcc8a2682e4ef69ff8177a8239fb6"
      ],
      "sourceCharacterId": 276,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.smallmap.TurnShine"
    },
    "turnSkipGlow": {
      "path": "/game/ui/classic/turnSkipGlow/frame-00.svg",
      "frames": [
        "/game/ui/classic/turnSkipGlow/frame-00.svg"
      ],
      "width": 86,
      "height": 41,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "e31022ee3ed740344619aedaba13dec62515662d75b79a951f8aab785d065970"
      ],
      "sourceCharacterId": 59,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.game.mark.SkipShine"
    },
    "windFrame": {
      "path": "/game/ui/classic/windFrame/frame-00.svg",
      "frames": [
        "/game/ui/classic/windFrame/frame-00.svg"
      ],
      "width": 70,
      "height": 43,
      "anchor": {
        "x": 17,
        "y": 11
      },
      "frameRate": 25,
      "sha256": [
        "70bb0c9298e5e116e2a1961fca5dbcef35bc8570e86c2a38134f20db9c5685ab"
      ],
      "sourceCharacterId": 168,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009"
    },
    "windInset": {
      "path": "/game/ui/classic/windInset/frame-00.svg",
      "frames": [
        "/game/ui/classic/windInset/frame-00.svg"
      ],
      "width": 65,
      "height": 36,
      "anchor": {
        "x": 15,
        "y": 7
      },
      "frameRate": 25,
      "sha256": [
        "059f1c5090b2d606edb1c019587afe66de8422c8078d180ea87fbbf485ff17c6"
      ],
      "sourceCharacterId": 169,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009"
    },
    "windChevrons": {
      "path": "/game/ui/classic/windChevrons/frame-00.svg",
      "frames": [
        "/game/ui/classic/windChevrons/frame-00.svg",
        "/game/ui/classic/windChevrons/frame-01.svg",
        "/game/ui/classic/windChevrons/frame-02.svg",
        "/game/ui/classic/windChevrons/frame-03.svg",
        "/game/ui/classic/windChevrons/frame-04.svg",
        "/game/ui/classic/windChevrons/frame-05.svg"
      ],
      "width": 82,
      "height": 43,
      "anchor": {
        "x": 46,
        "y": 14
      },
      "frameRate": 25,
      "sha256": [
        "221ef4d8df4dd5a6eb1320bfa20cc2790ca1ad29e730b16645d007e527f3d08b",
        "d6e10324d5f2130e136a5049623aa6ebe2523ef24bb2680db3dc0e2c7e0edcc1",
        "c1a9d1e080eac6f9016c066da35417c5dfeb0dab1890b65c173a5159394fc15f",
        "268e0287cd5a8eb5f792f5abd2b8412e8e8370d6ddc8f954ccce31b00c2f1d05",
        "20bd0a903268c76a3e3621a9c3fd505846f6b2e1244492969b3181f9c22bc2db",
        "fbb2b8041dbbff275b30d8f88b6906783c5a30d2d4b29ab612d3aed4cf48c7e7"
      ],
      "sourceCharacterId": 172,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009"
    },
    "windPinwheel": {
      "path": "/game/ui/classic/windPinwheel/frame-00.svg",
      "frames": [
        "/game/ui/classic/windPinwheel/frame-00.svg",
        "/game/ui/classic/windPinwheel/frame-01.svg",
        "/game/ui/classic/windPinwheel/frame-02.svg",
        "/game/ui/classic/windPinwheel/frame-03.svg",
        "/game/ui/classic/windPinwheel/frame-04.svg",
        "/game/ui/classic/windPinwheel/frame-05.svg",
        "/game/ui/classic/windPinwheel/frame-06.svg"
      ],
      "width": 14,
      "height": 14,
      "anchor": {
        "x": 7,
        "y": 7
      },
      "frameRate": 25,
      "sha256": [
        "8dd762e65e789fcbd3328d1573b9fc470722df7111ad83d2ba60b2826c2d6ef8",
        "80da48c17947bedeaaab88ad71ee141e70b9abc0dd84c37bb4d82468f961bfbb",
        "b85bda4fec9f4210390a53d2a325bfc732b9e339ae9d721497fa5af62c706341",
        "de0b4d7f331a5257c3350e4fe605015659ee63e63bfbe0d330561ed516b1716a",
        "c0edfc8f02fb804d83b902b3faebc79eaab3dc92d62d9548bd5e0db5094f9ca8",
        "0d572924cde22045082cca9f467683af537e152e7ffbe4224a4854aa05c8d887",
        "dda255c71a68004027e4b148a81fb4993fc5d99663a8a175d2b169ba167d7600"
      ],
      "sourceCharacterId": 180,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009"
    },
    "windGlint": {
      "path": "/game/ui/classic/windGlint/frame-00.svg",
      "frames": [
        "/game/ui/classic/windGlint/frame-00.svg"
      ],
      "width": 67,
      "height": 20,
      "anchor": {
        "x": 16,
        "y": 9
      },
      "frameRate": 25,
      "sha256": [
        "4620425def675596e40836a564c5a14fa1dd4da2b6e3f2da1937a6b82bfaba86"
      ],
      "sourceCharacterId": 181,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009"
    },
    "windTitle": {
      "path": "/game/ui/classic/windTitle.png",
      "width": 77,
      "height": 19,
      "symbol": "asset.game.vaneTitleAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 12,
      "sha256": "3214d5292b993bd1895bfe6aaea2c5622ca02dcee8eff248d8006ff03ffc4f35",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "windPrevious": {
      "path": "/game/ui/classic/windPrevious.png",
      "width": 110,
      "height": 18,
      "symbol": "asset.game.vanePreviousAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 73,
      "sha256": "0c2c1f9dc93ab67b88a9a25b23d463665297a6452a650abf75b0f58fb6197496",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "windPreviousDirection": {
      "path": "/game/ui/classic/windPreviousDirection.png",
      "width": 19,
      "height": 14,
      "symbol": "asset.game.vanePreviousDirectionAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 72,
      "sha256": "a18ba86c9a90d19b05c8e6ee39ea03d53e905e94774f45f820b1ba6cc394286b",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "powerBackFull": {
      "path": "/game/ui/classic/powerBackFull.png",
      "width": 554,
      "height": 46,
      "symbol": "asset.game.power.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 110,
      "sha256": "0ffee5b42b12bace8e726c8532848ee18735661befe3f86c174346b48cc32a54",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "powerRuler": {
      "path": "/game/ui/classic/powerRuler.png",
      "width": 497,
      "height": 16,
      "symbol": "asset.game.rulingAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 46,
      "sha256": "42c21d6ac8198a2641f5aa8a9c1b12938624054835335178eae2efd6b0504ee9",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "powerRulerGray": {
      "path": "/game/ui/classic/powerRulerGray.png",
      "width": 498,
      "height": 20,
      "symbol": "asset.game.rulingGrayStripAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 44,
      "sha256": "7450a7b987cd57049cc1b4da7125f680dde9382018ea0481951db97bfb920b8f",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "powerRulerLight": {
      "path": "/game/ui/classic/powerRulerLight.png",
      "width": 498,
      "height": 20,
      "symbol": "asset.game.rulingLightStripAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 43,
      "sha256": "629d9c08111f56f1b3c0394a4d07966ee95d88d6174b868a7ca82e3151c5ca7d",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "powerMarker": {
      "path": "/game/ui/classic/powerMarker.png",
      "width": 24,
      "height": 34,
      "symbol": "asset.game.rulingBtnAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 45,
      "sha256": "087fc814ddad8d1ebae0f564b8cf7a599235d07b6b61bec41ff0e05e96b4f626",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "angleBack": {
      "path": "/game/ui/classic/angleBack.png",
      "width": 104,
      "height": 104,
      "symbol": "asset.game.angle.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 109,
      "sha256": "89b4836b36387cd1cbc3ba77ea2e9a53319e681517a8c9a58efaf9ba29698bf7",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "angleDial": {
      "path": "/game/ui/classic/angleDial.png",
      "width": 88,
      "height": 88,
      "symbol": "asset.game.angle.dail",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 83,
      "sha256": "fd82d61a3bae175c07101eb293dfcb92ce235c5e6d737d7c4c173968bfbed145",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "angleHalfRound": {
      "path": "/game/ui/classic/angleHalfRound.png",
      "width": 98,
      "height": 98,
      "symbol": "asset.game.angle.halfround",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 76,
      "sha256": "06f3c932d14d0334fcdc6e7f2d8d57bc6552dac6922b547fd5c1bf78a95c9583",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "angleNeedle": {
      "path": "/game/ui/classic/angleNeedle.png",
      "width": 51,
      "height": 4,
      "symbol": "asset.game.handAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 75,
      "sha256": "edfa4ac034458eb9e2bb58723bc65fc9d789e2a17353887da5a08981c07665d7",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "angleNeedleCenter": {
      "path": "/game/ui/classic/angleNeedleCenter.png",
      "width": 11,
      "height": 11,
      "symbol": "asset.game.arrowCenterAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 91,
      "sha256": "c72e5208917f91301ac157a8a145fa1b78eebea95013d5d8b2680d46b3cca715",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "danderBack": {
      "path": "/game/ui/classic/danderBack.png",
      "width": 103,
      "height": 104,
      "symbol": "asset.game.dander.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 132,
      "sha256": "231933eb519b11b0b5b5aee889e7f38d92fd42deaf0d47997afc6fab46f19a7a",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "danderBg": {
      "path": "/game/ui/classic/danderBg.png",
      "width": 102,
      "height": 104,
      "symbol": "asset.game.dander.bg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 81,
      "sha256": "6314c6e558fd778f7f61c8ebb36d4f418abfbe449c17a1473904a645764efe60",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "healthBack": {
      "path": "/game/ui/classic/healthBack.png",
      "width": 167,
      "height": 47,
      "symbol": "asset.game.health.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 111,
      "sha256": "ac09bd5092c18deaad1546a9a0c8b6dff52693cd026ae8c96712cd53f598c5f0",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "energyBack": {
      "path": "/game/ui/classic/energyBack.png",
      "width": 108,
      "height": 12,
      "symbol": "asset.game.energy.back",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 79,
      "sha256": "56b72bff83f86ce6eeed019ec489c612ed38f061f54ac8f0eba1bbe0dd73c5c6",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "weaponBack": {
      "path": "/game/ui/classic/weaponBack.png",
      "width": 88,
      "height": 46,
      "symbol": "asset.game.prop.WeaponBack",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 11,
      "sha256": "6bac96da32c00303174e46fd3cb7caa422199a9cd9f3e7d4be22d0709f5346d6",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "propVerticalBack": {
      "path": "/game/ui/classic/propVerticalBack.png",
      "width": 46,
      "height": 322,
      "symbol": "asset.game.prop.RightBack2",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 55,
      "sha256": "b9a2507c56c4295bc8f67f3f78edc15d7b38e31407ca4ccbd9db8c2460bbdf63",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "propHorizontalBack": {
      "path": "/game/ui/classic/propHorizontalBack.png",
      "width": 322,
      "height": 46,
      "symbol": "asset.game.prop.RightBack1",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 56,
      "sha256": "c19e4aef96eb4c1f5c1db4bae15e6117a7f9cdef4d707cb0d0e59a153b49b706",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "propBack": {
      "path": "/game/ui/classic/propBack.png",
      "width": 144,
      "height": 54,
      "symbol": "asset.game.propBackAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 54,
      "sha256": "30ac1c6dcbf494750bf53d70d3e7a07d23d9e1913a7816a7c4fba0e527861240",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "propCell": {
      "path": "/game/ui/classic/propCell.png",
      "width": 37,
      "height": 37,
      "symbol": "asset.game.prop.ItemBack",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 93,
      "sha256": "d47f49ef4a067fb215d3641964b8ee0be0837d1f4accda8921436b660fd62c9a",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "propCellFore": {
      "path": "/game/ui/classic/propCellFore.png",
      "width": 33,
      "height": 18,
      "symbol": "asset.game.prop.ItemFore",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 92,
      "sha256": "afa7eaeeec1b8cb6e50ad7aae2134d38bc4d249936252e68d8e5ab7b8bbfec5d",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnSkip": {
      "path": "/game/ui/classic/turnSkip.png",
      "width": 80,
      "height": 35,
      "symbol": "asset.game.mark.SkipBack",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 60,
      "sha256": "c8f22d673ff0fbccc992ddf7abd4361ee2231adc2d8beb6093f2fcc9224e3bc8",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnRedBack": {
      "path": "/game/ui/classic/turnRedBack.png",
      "width": 128,
      "height": 78,
      "symbol": "asset.game.redNumberBackgoundAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 48,
      "sha256": "029f74c5057a40f5ea1f45bcf6e7c6ff79f2ff1a05a9917e652ffa3ec9f90bb6",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "mapTurnBack": {
      "path": "/game/ui/classic/mapTurnBack.png",
      "width": 59,
      "height": 16,
      "symbol": "asset.game.smallmap.TurnBack",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 13,
      "sha256": "934b14a321ddb6416000b2cf5a9802712efd6303042c8a435db3c6e793273aed",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "hpSelfBack": {
      "path": "/game/ui/classic/hpSelfBack.png",
      "width": 126,
      "height": 22,
      "symbol": "asset.game.blood.SelfBack",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 107,
      "sha256": "54a282e122c23a205ea661bb29e8ea4624e273ff6af6938c979e2f78d2f4fa9a",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnRed0": {
      "path": "/game/ui/classic/turn-red-0.png",
      "width": 58,
      "height": 66,
      "symbol": "asset.game.mark.Red0",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 49,
      "sha256": "30f212a9305adc57a7eb0612b368ebb9a80ff9143c3119afae35e06818df188f",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue0": {
      "path": "/game/ui/classic/turn-blue-0.png",
      "width": 58,
      "height": 66,
      "symbol": "asset.game.mark.Blue0",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 97,
      "sha256": "551624f9fc5c34b20091c49cf27c7d7bed094fe284b31482ecfd09b213057841",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnRed1": {
      "path": "/game/ui/classic/turn-red-1.png",
      "width": 39,
      "height": 66,
      "symbol": "asset.game.mark.Red1",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 53,
      "sha256": "39264a83aeff4713c4f0b08cca109eda7e12bb4a75dd86bf72345b20e7ed00cd",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue1": {
      "path": "/game/ui/classic/turn-blue-1.png",
      "width": 39,
      "height": 66,
      "symbol": "asset.game.mark.Blue1",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 106,
      "sha256": "54a6e9c28b4a3fe78acf6249caba658c6d41ba03e2811b6bb7c9a4f64e1118ca",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnRed2": {
      "path": "/game/ui/classic/turn-red-2.png",
      "width": 57,
      "height": 66,
      "symbol": "asset.game.mark.Red2",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 52,
      "sha256": "2283c50c7bc37fc23ccb097122e4a50ed1cde762504797a9887e41c192b67b6d",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue2": {
      "path": "/game/ui/classic/turn-blue-2.png",
      "width": 57,
      "height": 66,
      "symbol": "asset.game.mark.Blue2",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 105,
      "sha256": "a01473e9eadd7b07dff87c258abeafd7e81487d1ab3eff31211278936e806ac3",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnRed3": {
      "path": "/game/ui/classic/turn-red-3.png",
      "width": 56,
      "height": 67,
      "symbol": "asset.game.mark.Red3",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 51,
      "sha256": "1e53bb9fcb93a6e8d2007cb3718396fd73589eebc3b37f34f842ae111ff7e786",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue3": {
      "path": "/game/ui/classic/turn-blue-3.png",
      "width": 57,
      "height": 67,
      "symbol": "asset.game.mark.Blue3",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 104,
      "sha256": "b5815459a0da9225d28ab42b591a07d5c47ed75229b45daf94fcf5459dbf7fa0",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnRed4": {
      "path": "/game/ui/classic/turn-red-4.png",
      "width": 58,
      "height": 65,
      "symbol": "asset.game.mark.Red4",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 50,
      "sha256": "f73ae48e72a2e5406e410098345d15e176d02432f03eb963ef41acb8695956aa",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue4": {
      "path": "/game/ui/classic/turn-blue-4.png",
      "width": 58,
      "height": 65,
      "symbol": "asset.game.mark.Blue4",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 103,
      "sha256": "c9e83865ca99504141bc6c2e8a2d0bdddb2bd715d66f00ce815f32cb05093984",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue5": {
      "path": "/game/ui/classic/turn-blue-5.png",
      "width": 57,
      "height": 66,
      "symbol": "asset.game.mark.Blue5",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 102,
      "sha256": "a556fa872f48b6f96138ec907d0a59d8c7c63a5d44ea010bf85e41aea33ee9d9",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue6": {
      "path": "/game/ui/classic/turn-blue-6.png",
      "width": 57,
      "height": 67,
      "symbol": "asset.game.mark.Blue6",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 101,
      "sha256": "2851f3e43851a1d5d944d00ccfde58614a550c3c4ba796a280c29574b9bacd85",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue7": {
      "path": "/game/ui/classic/turn-blue-7.png",
      "width": 55,
      "height": 65,
      "symbol": "asset.game.mark.Blue7",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 100,
      "sha256": "dc0f754edcc1ab27370e6a1b140e609756e383945d3ab514e8f36e0adcab2bd4",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue8": {
      "path": "/game/ui/classic/turn-blue-8.png",
      "width": 57,
      "height": 67,
      "symbol": "asset.game.mark.Blue8",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 99,
      "sha256": "252c367b5295c26129b3020b4470e635b60258b495686d24e6409123b3ea2282",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "turnBlue9": {
      "path": "/game/ui/classic/turn-blue-9.png",
      "width": 57,
      "height": 67,
      "symbol": "asset.game.mark.Blue9",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/gameiii.swf",
      "sourceCharacterId": 98,
      "sha256": "c3284cc1d6970a2288bbc6711c1815feec7d30c0a6728acdc9391b9f3c1f1540",
      "sourceSha256": "5b706f2c0f26bd5f0a6621c0da809352f0272cfea789a1fa595cb9fe5b501be7",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomWaitingCard": {
      "path": "/game/ui/classic/roomWaitingCard.png",
      "width": 180,
      "height": 189,
      "symbol": "asset.ddtroom.playerItem.waitingBg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 38,
      "sha256": "e3da8ded78e362fbfc59781b43d8f2bd3f41574d77a230047b3d5fd0c5957d64",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomOccupiedCard": {
      "path": "/game/ui/classic/roomOccupiedCard.png",
      "width": 180,
      "height": 189,
      "symbol": "asset.ddtroom.playerItem.yellowbg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 35,
      "sha256": "ce61cc8a7f83e17488c65b538b15fb5c77cea1208de2a1baef55a3b7ae1a0d9f",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomClosedCard": {
      "path": "/game/ui/classic/roomClosedCard.png",
      "width": 179,
      "height": 189,
      "symbol": "asset.ddtroom.playerItem.closeBg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 90,
      "sha256": "bcad74d9e7ec3c7ce6eb9407af6d9718f4a11685208c2a3db39af5b900495ccb",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomReadyStamp": {
      "path": "/game/ui/classic/roomReadyStamp.png",
      "width": 105,
      "height": 105,
      "symbol": "asset.ddtroom.playerItem.ReadyIconAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 59,
      "sha256": "2ac8d266f5418e28373e8a8fa48f6b0d86508790071b2dde6a2a1252d2b74047",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomCardRedOutline": {
      "path": "/game/ui/classic/roomCardRedOutline.png",
      "width": 182,
      "height": 191,
      "symbol": "asset.ddtroom.playerItem.redLight",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 58,
      "sha256": "66a60dd6ab636978ce26d2016f3bedd5198749ce871ee514b51a2f1eb34a141e",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomCardBlueOutline": {
      "path": "/game/ui/classic/roomCardBlueOutline.png",
      "width": 182,
      "height": 191,
      "symbol": "asset.ddtroom.playerItem.blueLight",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 99,
      "sha256": "99f3896840d06a9eb27ed768938aa0e792be686802709938d1ac09d2e149631a",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomNameBack": {
      "path": "/game/ui/classic/roomNameBack.png",
      "width": 203,
      "height": 29,
      "symbol": "asset.ddtroom.roomNameBgAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 55,
      "sha256": "c76bc48d6485ea5782bd94cc20808cb7e7c1b390924b1cec8fd80326501e7585",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomMapInfoBack": {
      "path": "/game/ui/classic/roomMapInfoBack.png",
      "width": 307,
      "height": 82,
      "symbol": "asset.ddtroom.bigMapInfo.smallBg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 47,
      "sha256": "288359eed555e818e2a1447bc1ea9d6cdaa30c6129d38ad9e6937ec277b02619",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomPropCell": {
      "path": "/game/ui/classic/roomPropCell.png",
      "width": 53,
      "height": 52,
      "symbol": "asset.ddtroom.storeCellBgAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 43,
      "sha256": "f159439ff26048b87882d2388cef5cb1b04302ea69283ac10e1ffe793d80c2fc",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomActionBack": {
      "path": "/game/ui/classic/roomActionBack.png",
      "width": 92,
      "height": 96,
      "symbol": "asset.ddtroom.btnBg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 34,
      "sha256": "b91b31ba462455dcf818d4fe1c6f46ff63990b6254c7faa21d83d8c27ab81f51",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomMapChoose": {
      "path": "/game/ui/classic/roomMapChoose.png",
      "width": 70,
      "height": 29,
      "symbol": "asset.ddtroom.challenge.chooseMap",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceCharacterId": 91,
      "sha256": "84ad102e68252e2ef309e1edea975c323c8667edc766b873ec7611d99ec80c11",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "roomReadyCandidate": {
      "path": "/game/ui/classic/roomReadyCandidate/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomReadyCandidate/frame-00.svg"
      ],
      "width": 97,
      "height": 122,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "dee17b041334e2e58a98b2aa70e4b650eeb8519d6b2c16196e9375251bc7abb1"
      ],
      "sourceCharacterId": 192,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.ddtroom.preparMovie"
    },
    "roomCancelCandidate": {
      "path": "/game/ui/classic/roomCancelCandidate/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomCancelCandidate/frame-00.svg"
      ],
      "width": 98,
      "height": 121,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "51e9d171f1ed62c6106d8b924371eb55d16696a53001a9ac17ddc8ed01fb1fcd"
      ],
      "sourceCharacterId": 195,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.ddtroom.cancelAsset"
    },
    "roomStartCandidate": {
      "path": "/game/ui/classic/roomStartCandidate/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomStartCandidate/frame-00.svg"
      ],
      "width": 97,
      "height": 121,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "093b02d2d0703e57d28253d90a66a86e4f635865c4830a033f117c878c43e3e8"
      ],
      "sourceCharacterId": 198,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.ddtroom.startMovie"
    },
    "roomCardsPanel": {
      "path": "/game/ui/classic/roomCardsPanel/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomCardsPanel/frame-00.svg"
      ],
      "width": 386,
      "height": 377,
      "anchor": {
        "x": 1,
        "y": 1
      },
      "frameRate": 25,
      "sha256": [
        "cbeec86c0d2819d7eb2dde00d26724785e5d8d6ac456a7f998d56e22c44c94bc"
      ],
      "sourceCharacterId": 138,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.ddtroom.playerItemlist.bg"
    },
    "roomMapPanel": {
      "path": "/game/ui/classic/roomMapPanel/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomMapPanel/frame-00.svg"
      ],
      "width": 594,
      "height": 305,
      "anchor": {
        "x": 2,
        "y": 2
      },
      "frameRate": 25,
      "sha256": [
        "71278475e90229bc1fb9e8c57416e04c48469d9c3fa49d2879bac61a07685f9c"
      ],
      "sourceCharacterId": 143,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtroom.swf",
      "sourceSha256": "02ff534482e758afc5cbe7d06f80e9c225fe6af48aead5a9e2b240c7497d2e2a",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.ddtroom.dungeonChoose.middleBg"
    },
    "roomLeftFrame": {
      "path": "/game/ui/classic/roomLeftFrame/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomLeftFrame/frame-00.svg"
      ],
      "width": 232,
      "height": 423,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "d55d012d4a01250b785451389df78bb77b99c1d521d93152f9a2328e3d4cdcb4"
      ],
      "sourceCharacterId": 265,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcorescalebitmap.swf",
      "sourceSha256": "2003b1fda7942d33a472189b08a49c76a0917efad3d5737a967ca424ed697da9",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.background.room.left"
    },
    "roomRightFrame": {
      "path": "/game/ui/classic/roomRightFrame/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomRightFrame/frame-00.svg"
      ],
      "width": 762,
      "height": 518,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "90a6d0379c2fcca87420baf14dee450ec9827ef12ae78803857f00d85a57238c"
      ],
      "sourceCharacterId": 253,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcorescalebitmap.swf",
      "sourceSha256": "2003b1fda7942d33a472189b08a49c76a0917efad3d5737a967ca424ed697da9",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.background.room.right"
    },
    "roomListLeftFrame": {
      "path": "/game/ui/classic/roomListLeftFrame/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomListLeftFrame/frame-00.svg"
      ],
      "width": 232,
      "height": 542,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "685009bcbd83be8aefb5551223a32fd23d7ab8163a4d37d7b3c8b4efa3a62e12"
      ],
      "sourceCharacterId": 261,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcorescalebitmap.swf",
      "sourceSha256": "2003b1fda7942d33a472189b08a49c76a0917efad3d5737a967ca424ed697da9",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.background.roomlist.left"
    },
    "roomListRightFrame": {
      "path": "/game/ui/classic/roomListRightFrame/frame-00.svg",
      "frames": [
        "/game/ui/classic/roomListRightFrame/frame-00.svg"
      ],
      "width": 762,
      "height": 384,
      "anchor": {
        "x": 0,
        "y": 0
      },
      "frameRate": 25,
      "sha256": [
        "077553a9654ba3cfc0347872d869fd57a42a65ccb2e5fcf0a0ba9f097fee5e91"
      ],
      "sourceCharacterId": 257,
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcorescalebitmap.swf",
      "sourceSha256": "2003b1fda7942d33a472189b08a49c76a0917efad3d5737a967ca424ed697da9",
      "derivation": "Exact archived SWF ShapeRecord paths, fill colors, gradients, depth, MATRIX and ShowFrame order converted to SVG; no redraw or ActionScript execution",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; geometry is not independently dated to 2009",
      "symbol": "asset.background.roomlist.right"
    },
    "coreWoodTitle": {
      "path": "/game/ui/classic/coreWoodTitle.png",
      "width": 374,
      "height": 58,
      "symbol": "asset.ddtcore.title2Bg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcoreii.swf",
      "sourceCharacterId": 51,
      "sha256": "61d4044c2e062f783c699040aa3ced79a0f5e75d448c976b9acada9ed496f43e",
      "sourceSha256": "4bbec7731f53093fd4994b7a8c94c80242140cbff7cdc88aeec3f78085f13a90",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "coreBrownPanel": {
      "path": "/game/ui/classic/coreBrownPanel.png",
      "width": 187,
      "height": 208,
      "symbol": "asset.ddtcore.frameBg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcoreii.swf",
      "sourceCharacterId": 46,
      "sha256": "4fa78cf4b203e8556f5dd3575308f5a93567cd51b1314ea97a0085e58706cc41",
      "sourceSha256": "4bbec7731f53093fd4994b7a8c94c80242140cbff7cdc88aeec3f78085f13a90",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "coreSmallPanel": {
      "path": "/game/ui/classic/coreSmallPanel.png",
      "width": 185,
      "height": 39,
      "symbol": "asset.core.pagePreBg",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcoreii.swf",
      "sourceCharacterId": 41,
      "sha256": "66cb2f40867743b954230d09930b0a28f51926738f623164e00df08b57659c67",
      "sourceSha256": "4bbec7731f53093fd4994b7a8c94c80242140cbff7cdc88aeec3f78085f13a90",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "coreItemCell": {
      "path": "/game/ui/classic/coreItemCell.png",
      "width": 47,
      "height": 46,
      "symbol": "bagAndInfo.cell.bagCellBgAsset",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcoreii.swf",
      "sourceCharacterId": 215,
      "sha256": "e5dcfd557e571583518d2eb91354806c881af78609c0f0525b011bd9d0de7bb5",
      "sourceSha256": "4bbec7731f53093fd4994b7a8c94c80242140cbff7cdc88aeec3f78085f13a90",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "coreGreenButton": {
      "path": "/game/ui/classic/coreGreenButton.png",
      "width": 62,
      "height": 26,
      "symbol": "asset.core.littleGreenBtn",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcoreii.swf",
      "sourceCharacterId": 131,
      "sha256": "05f2af40e2b8715ededdbdfcc786d58e855030e05dffe5c60eb412411521f09b",
      "sourceSha256": "4bbec7731f53093fd4994b7a8c94c80242140cbff7cdc88aeec3f78085f13a90",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "coreRedButton": {
      "path": "/game/ui/classic/coreRedButton.png",
      "width": 62,
      "height": 26,
      "symbol": "asset.core.redBtn",
      "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/ddtcoreii.swf",
      "sourceCharacterId": 217,
      "sha256": "15ddb54a7bd07d276e9048090607837855f3f9bf2543455ad56255cbb622b049",
      "sourceSha256": "4bbec7731f53093fd4994b7a8c94c80242140cbff7cdc88aeec3f78085f13a90",
      "derivation": "Original embedded bitmap decoded without repaint or crop",
      "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
    },
    "parchmentFrame": {
      "pieces": [
        {
          "path": "/game/ui/classic/parchmentFrame-1.png",
          "width": 52,
          "height": 55,
          "symbol": "asset.core.NewScale9CornerImage1.1",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 50,
          "sha256": "2fc28828986c15ccbd8fa44595f75ab2bb0162c12fc9f239ffd17ca1db0998fd",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-2.png",
          "width": 2,
          "height": 55,
          "symbol": "asset.core.NewScale9CornerImage1.2",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 48,
          "sha256": "dc0c5d10ada04cf181249f3818e97fdd020de5beef1a7c510ef0efada4121da0",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-3.png",
          "width": 52,
          "height": 55,
          "symbol": "asset.core.NewScale9CornerImage1.3",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 46,
          "sha256": "46edcc6dab8f2ad0dc225023d39ffdf5c4f52a71f7a4530f5385391934a866e1",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-4.png",
          "width": 52,
          "height": 2,
          "symbol": "asset.core.NewScale9CornerImage1.4",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 44,
          "sha256": "78cd2d7ff12a7d8dbadec85abef605f978400279787bd0c44fb80bb9db4eeabf",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-5.png",
          "width": 4,
          "height": 5,
          "symbol": "asset.core.NewScale9CornerImage1.5",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 42,
          "sha256": "2cdbe0ec27563d4e68be8d3e49752bdc1bbc32792f43f55a1ec325170e2f76b1",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-6.png",
          "width": 52,
          "height": 1,
          "symbol": "asset.core.NewScale9CornerImage1.6",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 40,
          "sha256": "e9f7c603885c203b536d904c76c77de4151990b1017c02143c628e09121d35db",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-7.png",
          "width": 52,
          "height": 55,
          "symbol": "asset.core.NewScale9CornerImage1.7",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 38,
          "sha256": "533c93d608b559e5c8e5330c24de8981c1c7975c2151ce8687783e9583a796cc",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-8.png",
          "width": 2,
          "height": 55,
          "symbol": "asset.core.NewScale9CornerImage1.8",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 36,
          "sha256": "95b13763f8e11ed8e6cd1d151e3389f3a928c6c4a6f2132129a30753c68bc253",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/parchmentFrame-9.png",
          "width": 52,
          "height": 55,
          "symbol": "asset.core.NewScale9CornerImage1.9",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 34,
          "sha256": "311add5e72d35f5bcf3614e72a2e33beb943180631ac9396e9ddc66970880fb1",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        }
      ],
      "derivation": "Original 9-piece Scale9CornerImage bitmap set in row-major order; preserve corners while scaling only edge/center strips",
      "candidateConfidence": "Archived original client candidate; exact 2009 use pending"
    },
    "woodFrame": {
      "pieces": [
        {
          "path": "/game/ui/classic/woodFrame-1.png",
          "width": 50,
          "height": 79,
          "symbol": "asset.core.NewScale9CornerImage7.1",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 49,
          "sha256": "658917c9e04122e81545c0e21f6953fef248c4a2d540cb2820571ad6055cb35b",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-2.png",
          "width": 7,
          "height": 79,
          "symbol": "asset.core.NewScale9CornerImage7.2",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 47,
          "sha256": "856ca6c5a48d04c19e3220216e87da7ea75245fb6ec8044fb76eedebc8797307",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-3.png",
          "width": 50,
          "height": 79,
          "symbol": "asset.core.NewScale9CornerImage7.3",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 45,
          "sha256": "cca0ee80a3bd026cab8d814e331f00692d52fee672dd9b6b51b35166f242408f",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-4.png",
          "width": 50,
          "height": 8,
          "symbol": "asset.core.NewScale9CornerImage7.4",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 43,
          "sha256": "6592257d90cf703a2b2e6ad184e4bd37a8879f2854cb8a2c8e76eb8c18c1d194",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-5.png",
          "width": 1,
          "height": 1,
          "symbol": "asset.core.NewScale9CornerImage7.5",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 41,
          "sha256": "f2bb5bbaca678ecad746b1fa5ecfa2c8a81dd18817be19f0187c036d25326317",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-6.png",
          "width": 50,
          "height": 8,
          "symbol": "asset.core.NewScale9CornerImage7.6",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 39,
          "sha256": "209dfa7c1cab80014276f618ca6eac9b68a85358ecccb81e8012e6252b132fbf",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-7.png",
          "width": 50,
          "height": 79,
          "symbol": "asset.core.NewScale9CornerImage7.7",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 37,
          "sha256": "96316f28a50fccb44bf496654d4112f9bb4466ee5589c1a403b70e2be93fd3cd",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-8.png",
          "width": 7,
          "height": 79,
          "symbol": "asset.core.NewScale9CornerImage7.8",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 35,
          "sha256": "2e8bb7424ecb753a22269fe9f38602c5ff96597eb1de4010ed4121456edfea46",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/woodFrame-9.png",
          "width": 50,
          "height": 79,
          "symbol": "asset.core.NewScale9CornerImage7.9",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 33,
          "sha256": "cd9c247977a6ad607392409b9c19c059b88dd2a77dc12eefeb36fc7616dd33ec",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        }
      ],
      "derivation": "Original 9-piece Scale9CornerImage bitmap set in row-major order; preserve corners while scaling only edge/center strips",
      "candidateConfidence": "Archived original client candidate; exact 2009 use pending"
    },
    "redButtonFrame": {
      "pieces": [
        {
          "path": "/game/ui/classic/redButtonFrame-1.png",
          "width": 44,
          "height": 22,
          "symbol": "asset.core.BigRedButton1",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 108,
          "sha256": "ebadf3e022123f70e7447a034a802d003fc3fd7dc43e240bd0c14a6cab3eff31",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-2.png",
          "width": 1,
          "height": 22,
          "symbol": "asset.core.BigRedButton2",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 107,
          "sha256": "086da57713647e403277ca5e8816bbc792e628e6fcd8c79513c8681fe7509f52",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-3.png",
          "width": 44,
          "height": 22,
          "symbol": "asset.core.BigRedButton3",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 106,
          "sha256": "48537dab6062734cc3cfa415e0966cc020c7b4e78d28d9507af0f0a4821edfee",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-4.png",
          "width": 44,
          "height": 1,
          "symbol": "asset.core.BigRedButton4",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 105,
          "sha256": "1384cf7cccbe4c6ddb391f75755586f352b3c993cd1da51d7b06ed5c0eb15da8",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-5.png",
          "width": 1,
          "height": 1,
          "symbol": "asset.core.BigRedButton5",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 104,
          "sha256": "1a54acbfb1cb0e415d07789b4f813a3991cb210bbc8d3d391898523e30e145e9",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-6.png",
          "width": 44,
          "height": 1,
          "symbol": "asset.core.BigRedButton6",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 103,
          "sha256": "b44f6a669b6e9b1dcf5e377abae17ee1b57f5becbfa5cbc2a36cdbac3b8b48e1",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-7.png",
          "width": 44,
          "height": 22,
          "symbol": "asset.core.BigRedButton7",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 102,
          "sha256": "4fcf54abf2c95be723cfbc115f7a0e4da160b0073bbba9673cda637480c346ac",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-8.png",
          "width": 1,
          "height": 22,
          "symbol": "asset.core.BigRedButton8",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 101,
          "sha256": "a7c211d5fc17c4ec01fd1a86b48709a7b2aa9074797b62065107ce1d4478cd1c",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        },
        {
          "path": "/game/ui/classic/redButtonFrame-9.png",
          "width": 44,
          "height": 22,
          "symbol": "asset.core.BigRedButton9",
          "sourcePath": "assets/candidate/original/ddtank-ii/ui/portugal/swf/firstcore.swf",
          "sourceCharacterId": 100,
          "sha256": "cb9f53c0f8b96dbd3b2a915293ab3a3af6f5721ef1635efba5a2369214539fe1",
          "sourceSha256": "a51af83eda06a6e88627e4845e6e1431cfe494fee1c8aada8f4b2fbb4701e8b6",
          "derivation": "Original embedded bitmap decoded without repaint or crop",
          "candidateConfidence": "Exact original source symbol, later archived client candidate; design is not independently dated to 2009"
        }
      ],
      "derivation": "Original 9-piece Scale9CornerImage bitmap set in row-major order; preserve corners while scaling only edge/center strips",
      "candidateConfidence": "Archived original client candidate; exact 2009 use pending"
    },
    "roomInvite2009": {
      "path": "/game/ui/classic/roomInvite2009.png",
      "width": 64,
      "height": 94,
      "sourcePath": "assets/reference/official/images/2009_28-3714_reference_04.jpg",
      "sourceSha256": "6d649b29cad973953010730880439bebf8e53076b7df110359cb0dc04d569c76",
      "sha256": "7352337d900bbab6556828b4611f58bc981c11cc2553cea2e39aa838f472c2d6",
      "crop": [
        0,
        0,
        64,
        94
      ],
      "derivation": "Unmodified pixel crop of a dated 2009 official screenshot; no redraw or generated content",
      "candidateConfidence": "2009 official contemporary design verified; screenshot crop includes its original wood backing",
      "description": "Original 2009 invite button",
      "provenance": [
        {
          "id": "2009_28-3714_reference_04",
          "label": "邀请换队准备按钮",
          "original_url": "http://img.my4399.com/uploads/userup/0904/2R03K2Gb.jpg",
          "page_url": "https://web.4399.com/ddt/youxiziliao/200904/28-3714.html",
          "published_date": "2009-04-28",
          "version": "2009 early Flash",
          "version_evidence": "4399官方旧版资料页日期与图片路径/0904/一致",
          "category": "UI/reference",
          "usage": "Official historical screenshot/reference; not separate runtime asset.",
          "path": "assets/reference/official/images/2009_28-3714_reference_04.jpg",
          "mime_type": "image/jpeg",
          "width": 214,
          "height": 90,
          "mode": "RGB",
          "bytes": 7599,
          "sha256": "6d649b29cad973953010730880439bebf8e53076b7df110359cb0dc04d569c76",
          "status": "downloaded",
          "downloaded_url": "http://img.my4399.com/uploads/userup/0904/2R03K2Gb.jpg",
          "has_transparency": false
        }
      ]
    },
    "roomSwitchTeam2009": {
      "path": "/game/ui/classic/roomSwitchTeam2009.png",
      "width": 71,
      "height": 94,
      "sourcePath": "assets/reference/official/images/2009_28-3714_reference_04.jpg",
      "sourceSha256": "6d649b29cad973953010730880439bebf8e53076b7df110359cb0dc04d569c76",
      "sha256": "ae599ed35d0250a8aa8512b66bfabbad7713707c6e091ca87f6f00af6d7c9bb0",
      "crop": [
        64,
        0,
        135,
        94
      ],
      "derivation": "Unmodified pixel crop of a dated 2009 official screenshot; no redraw or generated content",
      "candidateConfidence": "2009 official contemporary design verified; screenshot crop includes its original wood backing",
      "description": "Original 2009 change-team button",
      "provenance": [
        {
          "id": "2009_28-3714_reference_04",
          "label": "邀请换队准备按钮",
          "original_url": "http://img.my4399.com/uploads/userup/0904/2R03K2Gb.jpg",
          "page_url": "https://web.4399.com/ddt/youxiziliao/200904/28-3714.html",
          "published_date": "2009-04-28",
          "version": "2009 early Flash",
          "version_evidence": "4399官方旧版资料页日期与图片路径/0904/一致",
          "category": "UI/reference",
          "usage": "Official historical screenshot/reference; not separate runtime asset.",
          "path": "assets/reference/official/images/2009_28-3714_reference_04.jpg",
          "mime_type": "image/jpeg",
          "width": 214,
          "height": 90,
          "mode": "RGB",
          "bytes": 7599,
          "sha256": "6d649b29cad973953010730880439bebf8e53076b7df110359cb0dc04d569c76",
          "status": "downloaded",
          "downloaded_url": "http://img.my4399.com/uploads/userup/0904/2R03K2Gb.jpg",
          "has_transparency": false
        }
      ]
    },
    "roomReady2009": {
      "path": "/game/ui/classic/roomReady2009.png",
      "width": 78,
      "height": 94,
      "sourcePath": "assets/reference/official/images/2009_28-3714_reference_04.jpg",
      "sourceSha256": "6d649b29cad973953010730880439bebf8e53076b7df110359cb0dc04d569c76",
      "sha256": "8e776ae14ab853949e3e289dcf97e1a315a28f007796a1e12c8e29c061714d26",
      "crop": [
        135,
        0,
        213,
        94
      ],
      "derivation": "Unmodified pixel crop of a dated 2009 official screenshot; no redraw or generated content",
      "candidateConfidence": "2009 official contemporary design verified; screenshot crop includes its original wood backing",
      "description": "Original 2009 cartoon star preparation button",
      "provenance": [
        {
          "id": "2009_28-3714_reference_04",
          "label": "邀请换队准备按钮",
          "original_url": "http://img.my4399.com/uploads/userup/0904/2R03K2Gb.jpg",
          "page_url": "https://web.4399.com/ddt/youxiziliao/200904/28-3714.html",
          "published_date": "2009-04-28",
          "version": "2009 early Flash",
          "version_evidence": "4399官方旧版资料页日期与图片路径/0904/一致",
          "category": "UI/reference",
          "usage": "Official historical screenshot/reference; not separate runtime asset.",
          "path": "assets/reference/official/images/2009_28-3714_reference_04.jpg",
          "mime_type": "image/jpeg",
          "width": 214,
          "height": 90,
          "mode": "RGB",
          "bytes": 7599,
          "sha256": "6d649b29cad973953010730880439bebf8e53076b7df110359cb0dc04d569c76",
          "status": "downloaded",
          "downloaded_url": "http://img.my4399.com/uploads/userup/0904/2R03K2Gb.jpg",
          "has_transparency": false
        }
      ]
    },
    "woodTexture2009": {
      "path": "/game/ui/classic/woodTexture2009.png",
      "width": 160,
      "height": 40,
      "sourcePath": "assets/reference/official/images/2009_28-3714_reference_03.jpg",
      "sourceSha256": "c9e8b3badbdefd8ff5679aa170bf31a4a3da132c19a6adaecf218f9281ef882e",
      "sha256": "2c5d137084c513b3544d79015553ab51f9a992d9606849072b7bfb438d360969",
      "crop": [
        115,
        434,
        275,
        474
      ],
      "derivation": "Unmodified pixel crop of a dated 2009 official screenshot; no redraw or generated content",
      "candidateConfidence": "2009 official contemporary design verified; screenshot crop includes its original wood backing",
      "description": "Original 2009 room settings wood texture, free of text or controls",
      "provenance": [
        {
          "id": "2009_28-3714_reference_03",
          "label": "2009地图选择弹窗",
          "original_url": "http://img.my4399.com/uploads/userup/0904/2R03I454a.jpg",
          "page_url": "https://web.4399.com/ddt/youxiziliao/200904/28-3714.html",
          "published_date": "2009-04-28",
          "version": "2009 early Flash",
          "version_evidence": "4399官方旧版资料页日期与图片路径/0904/一致",
          "category": "UI/reference",
          "usage": "Official historical screenshot/reference; not separate runtime asset.",
          "path": "assets/reference/official/images/2009_28-3714_reference_03.jpg",
          "mime_type": "image/jpeg",
          "width": 600,
          "height": 483,
          "mode": "RGB",
          "bytes": 78434,
          "sha256": "c9e8b3badbdefd8ff5679aa170bf31a4a3da132c19a6adaecf218f9281ef882e",
          "status": "downloaded",
          "downloaded_url": "http://img.my4399.com/uploads/userup/0904/2R03I454a.jpg",
          "has_transparency": false
        }
      ]
    }
  },
  "warnings": []
}
